import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import App from "./app.component";
import * as serviceWorker from "./serviceWorker";

// console.log(`${process.env.REACT_APP_NAME} ${process.env.REACT_APP_VERSION}`);
const appName = process.env.REACT_APP_NAME;
const appVersion = process.env.REACT_APP_VERSION;
const environment = process.env.REACT_APP_ENVIRONMENT;

console.log(`%c${appName} v${appVersion} - [${environment}]`, "color: #4caf50; font-weight: bold;");

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
